import { PubDocsRouter } from './PubDocsRouter';
export { PubDocsRouter };
